// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';
import styles from './styles';

const InputWithRightButton = ({
  classes,
  outerStyleButton,
  name,
  value,
  textButton,
  placeholder,
  onChange,
  onPress
}) => {
  return (
    <div className={classNames(classes.container)}>
      <input
        type={'text'}
        name={name}
        value={value}
        onChange={e => onChange(e.currentTarget.value, name)}
        className={classNames('form-control', classes.styleInput)}
        placeholder={placeholder}
      />
      <button
        onClick={() => onPress()}
        className={classNames(classes.styleButton, outerStyleButton)}
        type={'button'}
      >
        <span className={classNames(classes.textButton)}>
          {textButton}
        </span>
      </button>
    </div>);
};

InputWithRightButton.propTypes = {
  classes: PropTypes.object,
  outerStyleButton: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  textButton: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onPress: PropTypes.func,
};

InputWithRightButton.defaultProps = {
  classes: {},
  outerStyleButton: '',
  value: '',
  textButton: 'Submit',
  placeholder: '',
  name: '',
  onChange: () => { },
  onPress: () => { },
};

export default withStyles(styles)(InputWithRightButton);
